// @ts-nocheck
import React, { useContext, useEffect } from 'react';
import Context from '../../context/Context';
import { fetchFormElement } from '../../context/forms/FormsAction';
import { useParams } from 'react-router-dom';
import { URL } from "../../service/Service";
import ElementEdit from "../../components/elementEdit/ElementEdit"

const ElementEditor = () => {
    const {idform, idformelement} = useParams()
    const {state, dispatch} = useContext(Context);
    const {loading, error, data} = state.formelement;


    useEffect(() => {
      const url = `${URL}/api/forms/${idform}/formelements/${idformelement}`;
      fetchFormElement(url, {} , dispatch);
  }, [dispatch, idform, idformelement]);

    if (loading) return <div className="p-8 text-center text-slate-600">A carregar elemento…</div>;
    if (error) return <div role="alert" className="m-8 rounded-2xl border border-red-200 bg-red-50 p-5 text-red-700">{error}</div>;


    return (
        <>
        <ElementEdit formElement={data}/>
        </>
    )
  }
  
  export default ElementEditor
